import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { AppointmentResponseDto } from '../../../../types/appointment.types';

interface Props {
  target: AppointmentResponseDto | null;
  cancelling: boolean;
  onConfirm: (reason: string) => void;
  onClose: () => void;
}

export const ExpertAppointmentCancelDialog: React.FC<Props> = ({ target, cancelling, onConfirm, onClose }) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (!target) setReason('');
  }, [target]);

  return (
    <Dialog open={target !== null} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Скасування зустрічі</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          multiline
          rows={3}
          margin="dense"
          label="Причина скасування"
          value={reason}
          onChange={e => setReason(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={cancelling}>Назад</Button>
        <Button
          color="error"
          variant="contained"
          onClick={() => onConfirm(reason)}
          disabled={!reason.trim() || cancelling}
        >
          Підтвердити
        </Button>
      </DialogActions>
    </Dialog>
  );
};
